import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import { Input, Select, Button } from 'antd';
import Icon, { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import { colors } from '../../styles/colors/';
import { Spacer } from '../Spacer/Spacer';
import ChevronDownIcon from '../Icons/ChevronDownIcon';

import { useWindowSize, sizes } from 'helpers/MediaHelper';

const StyledSearchButton = styled(Button)`
  width: 10%;
  min-width: 40px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: ${(props) => (props.isMobile ? '40px' : '32px')};
`;

const InputGroup = ({ onChange, options = [], defaultSelectValue, inputPlaceHolder }) => {
  const [selectVal, setSelectValue] = useState();
  const [inputVal, setInputValue] = useState();

  useEffect(() => {
    if (defaultSelectValue) {
      setSelectValue(defaultSelectValue);
    }
  }, [defaultSelectValue]);

  const [width] = useWindowSize();
  const isMobile = width <= sizes.mobile;

  const onSelectChange = (value) => {
    setSelectValue(value);
    onChange(value, inputVal);
  };

  const onInputChange = (e) => {
    setInputValue(e.target.value);
    onChange(selectVal, e.target.value);
  };

  const onButtonClick = () => {
    let newInputVal = inputVal;
    if (!isEmpty(inputVal)) {
      newInputVal = undefined;
    }

    setSelectValue(selectVal);
    setInputValue(newInputVal);
    onChange(selectVal, newInputVal);
  };

  const inputHeight = isMobile ? '40px' : '32px';

  // TODO: Remove all that CSS and replace with <Space.Compact /> once we upgrade antd to 4.24.X or higher
  const StyledCss = (
    <style>{css`
      .ant-select-dropdown-menu-item {
        color: ${colors['gray']['9']};
        font-size: ${isMobile ? '16px' : '14px'};
      }

      .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        border: 1px solid ${colors['gray']['3']};
      }

      .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
        box-shadow: none;
        border-color: ${colors['indigo']['7']};
      }

      .ant-select-focused .ant-select-selection,
      .ant-select-selection:focus,
      .ant-select-selection:active {
        border-color: ${colors['indigo']['7']};
        box-shadow: none;
      }

      .ant-select-selection:hover {
        border-color: ${colors['indigo']['7']};
        box-shadow: none;
      }

      .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
        .ant-select-selector {
        border-color: ${colors['indigo']['7']};
        box-shadow: none;
      }

      .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
        height: ${isMobile ? '40px' : '32px'};
      }

      .ant-select-selection-item {
        display: flex;
        align-items: center;
      }

      .ant-input {
        border: 1px solid ${colors['gray']['3']};
      }

      .ant-input:hover {
        border-color: ${colors['indigo']['7']};
      }

      .ant-input-focused,
      .ant-input:focus {
        border-color: ${colors['indigo']['7']};
        box-shadow: none;
      }

      .ant-btn:focus,
      .ant-btn:hover {
        color: ${colors['indigo']['7']};
        border-color: ${colors['indigo']['7']};
      }

      .ant-select-dropdown .ant-select-dropdown-placement-bottomLeft {
        min-width: 200px !important;
      }
    `}</style>
  );

  const iconComponent = isEmpty(inputVal) ? SearchOutlined : CloseOutlined;

  const suffixIcon = (
    <Spacer>
      <ChevronDownIcon />
    </Spacer>
  );

  return (
    <React.Fragment>
      {StyledCss}
      <Input.Group style={{ display: 'flex', maxWidth: '480px' }} compact>
        <Select
          suffixIcon={suffixIcon}
          style={{ width: '25%' }}
          value={selectVal}
          onChange={onSelectChange}
          dropdownStyle={{ minWidth: '150px' }}
        >
          {options.map((option, index) => (
            <Select.Option value={option.value} key={`${option.value}_${index}`}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
        <Input
          style={{ width: '65%', height: inputHeight }}
          placeholder={inputPlaceHolder}
          value={inputVal}
          onChange={onInputChange}
        />
        <StyledSearchButton onClick={() => onButtonClick()} isMobile={isMobile}>
          <Icon component={iconComponent} />
        </StyledSearchButton>
      </Input.Group>
    </React.Fragment>
  );
};

export { InputGroup };
